import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { Apps, CalenderHeading } from '../../../constants';
import DragCalendar from './dragCalendar';
import Breadcrumbs from '../../../coreComponents/breadcrumbs';
import { CalendarData } from '../../../types/Applications';
import { UserRole } from '../../../types/Forms';
import CommonCardHeader from '../../../coreComponents/CommonCardHeader';
import { useTranslation } from 'react-i18next';
interface CalendarContainerProps {
  calendarData: CalendarData[];
  role: UserRole;
  actionHandler?: (d: any) => void;
  openAddForm?: (d: any) => void;
  closeAddForm?: () => void;
  examDetailsGetter?: (id: number) => void;
  initialDate?: Date;
  onMonthChange?: (d: Date) => void;
  loading?: boolean;
  refetching?: boolean;
}
// This component renders a calendar interface with drag-and-drop functionality.
const CalendarContainer = ({
  calendarData,
  role,
  actionHandler,
  openAddForm,
  closeAddForm,
  examDetailsGetter,
  initialDate,
  onMonthChange,
  loading,
  refetching,
}: CalendarContainerProps) => {
  const { t } = useTranslation();
  return (
    <>
      {role === UserRole.STUDENT && <Breadcrumbs mainTitle={t('sidebar.examCalendar')} />}
      <Container fluid className="calendar-basic">
        <Card>
          <CommonCardHeader title={t('courses.exam.calendar.examCalendarTitle')} tag />
          <CardBody>
            <Row>
              <Col sm="12">
                <Row>
                  <DragCalendar
                    calendarData={calendarData}
                    role={role}
                    actionHandler={actionHandler}
                    openAddForm={openAddForm}
                    closeAddForm={closeAddForm}
                    examDetailsGetter={examDetailsGetter}
                    initialDate={initialDate}
                    onMonthChange={onMonthChange}
                    loading={loading}
                    refetching={refetching}
                  />
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default CalendarContainer;
